import { useCallback } from 'react'
import type { CarrierEntry } from './privileged-carriers'
import { useAuthServiceClient } from './sdk-client'
import { useCsvExport } from './use-csv-export'
import { useSdkList, type ListState } from './use-sdk-list'

export function usePrivilegedCarriers(): ListState<CarrierEntry> & { reload: () => void } {
  const getClient = useAuthServiceClient()
  const fetcher = useCallback(() => getClient().then((client) => client.auth.listPrivilegedCarriers()), [getClient])
  return useSdkList<CarrierEntry>(fetcher)
}

const exportRequest = (token: string) =>
  fetch('/api/v1/privileged_carriers/export', { headers: { Authorization: `Bearer ${token}` } })

export const useExportPrivilegedCarriers = () =>
  useCsvExport(exportRequest, 'privileged_carriers.csv', 'Could not export privileged carriers.')
